/**
 * MarketSegmentList — renders one `SymbolList` per market segment/feed.
 *
 * Iterates over `feedsScrips` from the metadata slice and renders a
 * per-segment symbol multi-select component for populating a watchlist.
 */
import { useSelector } from "react-redux";

import SymbolList from "../SymbolList";

const MarketSegmentList = ({ selectedSymbolsData, setSelectedSymbolsData }) => {
  const {
    feedsScripsState: { feedsScrips },
  } = useSelector(({ metadata }) => metadata);

  return (
    <div>
      <div className="market-segment-div">
        <div className="market-segment-toggle">
          <header>
            <h4 className="ms-divider" text-position="center">
              Add Symbols
            </h4>
          </header>
        </div>
        <div className="symbol-list">
          <div className="symbol-list-comp">
            {feedsScrips.map((feed) => (
              <SymbolList
                key={feed.id}
                feed={feed}
                selectedSymbolsData={selectedSymbolsData}
                setSelectedSymbolsData={setSelectedSymbolsData}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketSegmentList;
